const office = {
  id: 228,
  name: 'spaceTypes.office.name',
  displayOrder: 1,
};

const workstation = {
  id: 233,
  name: 'spaceTypes.workstation.name',
  displayOrder: 2,
};

const mobilitystation = {
  id: 232,
  name: 'spaceTypes.mobilityStation.name',
  displayOrder: 3,
};

const closedcollaboration = {
  id: 225,
  name: 'spaceTypes.closeCollaboration.name',
  displayOrder: 4,
};

const opencollaboration = {
  id: 230,
  name: 'spaceTypes.openCollaboration.name',
  displayOrder: 5,
};

const reception = {
  id: 231,
  name: 'spaceTypes.reception.name',
  displayOrder: 7,
};

const serviceareas = {
  id: 226,
  name: 'spaceTypes.serviceAreas.name',
  displayOrder: 8,
};

const pantry = {
  id: 227,
  name: 'spaceTypes.pantry.name',
  displayOrder: 9,
};

const filingcabinets = {
  id: 224,
  name: 'spaceTypes.filingCabinets.name',
  displayOrder: 10,
};

const specific = {
  id: 234,
  name: 'spaceTypes.specific.name',
  displayOrder: 11,
};

export const spaceTypes = {
  office,
  workstation,
  mobilitystation,
  closedcollaboration,
  opencollaboration,
  reception,
  serviceareas,
  pantry,
  filingcabinets,
  specific,
};

export const getSpaceTypeById = (id) => {
  const spaceType = Object.values(spaceTypes).find((spType) => spType.id === id);

  // TODO logger
  if (!spaceType) throw Error('getSpaceTypeById called with non available id: ' + id);

  return spaceType;
};
